<template>
  <Teleport to="body">
    <div v-if="open" class="share-overlay" @click.self="$emit('close')">
      <div class="share-panel">
        <div class="share-header">
          <h3>Share Tour</h3>
          <button @click="$emit('close')" class="close-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <!-- Social Share -->
        <div class="share-section">
          <p class="share-label">Share to</p>
          <div class="social-buttons">
            <button @click="shareToFacebook" class="social-btn facebook" title="Facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"/>
              </svg>
            </button>
            <button @click="shareToTwitter" class="social-btn twitter" title="X (Twitter)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </button>
            <button @click="shareToWhatsApp" class="social-btn whatsapp" title="WhatsApp">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </button>
            <button @click="shareToLinkedIn" class="social-btn linkedin" title="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </button>
            <button @click="shareByEmail" class="social-btn email" title="Email">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Tour Link -->
        <div class="share-section">
          <p class="share-label">Tour link</p>
          <div class="copy-row">
            <input :value="tourUrl" readonly class="copy-input" ref="linkInput" />
            <button @click="copyLink" class="copy-btn" :class="{ copied: linkCopied }">
              {{ linkCopied ? '✓' : 'Copy' }}
            </button>
          </div>
        </div>

        <!-- Embed Code -->
        <div v-if="props.showEmbed !== false" class="share-section">
          <p class="share-label">Embed code</p>
          <div class="copy-row">
            <textarea :value="embedCode" readonly class="copy-input embed-textarea" rows="3" ref="embedInput" />
            <button @click="copyEmbed" class="copy-btn" :class="{ copied: embedCopied }">
              {{ embedCopied ? '✓' : 'Copy' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

const props = defineProps<{
  open: boolean
  tourTitle: string
  tourId: string
  shareUrl?: string
  /** override the default tour iframe snippet (e.g. video embeds) */
  embedCode?: string
  tracker?: { trackShare: (platform: string) => void } | null
  showEmbed?: boolean
}>()

defineEmits<{ close: [] }>()

const linkCopied = ref(false)
const embedCopied = ref(false)

const tourUrl = computed(() => props.shareUrl || window.location.href)

const embedCode = computed(() =>
  props.embedCode ||
  `<iframe src="${tourUrl.value}" width="100%" height="500" frameborder="0" allowfullscreen allow="xr-spatial-tracking; gyroscope; accelerometer" title="${props.tourTitle}"></iframe>`
)

function track(platform: string) {
  props.tracker?.trackShare(platform)
}

function copyLink() {
  navigator.clipboard.writeText(tourUrl.value)
  linkCopied.value = true
  track('copy_link')
  setTimeout(() => (linkCopied.value = false), 2000)
}

function copyEmbed() {
  navigator.clipboard.writeText(embedCode.value)
  embedCopied.value = true
  track('copy_embed')
  setTimeout(() => (embedCopied.value = false), 2000)
}

function shareToFacebook() {
  track('facebook')
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(tourUrl.value)}`, '_blank', 'width=600,height=400')
}

function shareToTwitter() {
  track('twitter')
  window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(tourUrl.value)}&text=${encodeURIComponent(props.tourTitle)}`, '_blank', 'width=600,height=400')
}

function shareToWhatsApp() {
  track('whatsapp')
  window.open(`https://wa.me/?text=${encodeURIComponent(props.tourTitle + ' ' + tourUrl.value)}`, '_blank')
}

function shareToLinkedIn() {
  track('linkedin')
  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(tourUrl.value)}`, '_blank', 'width=600,height=400')
}

function shareByEmail() {
  track('email')
  window.location.href = `mailto:?subject=${encodeURIComponent(props.tourTitle + ' - 360° Virtual Tour')}&body=${encodeURIComponent('Check out this virtual tour: ' + tourUrl.value)}`
}
</script>

<style scoped>
.share-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.share-panel {
  background: #1e293b;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 440px;
  color: white;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.share-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.share-header h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s;
}

.close-btn:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}

.share-section {
  margin-bottom: 20px;
}

.share-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 10px;
  font-weight: 500;
}

.social-buttons {
  display: flex;
  gap: 10px;
}

.social-btn {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.social-btn:hover { transform: translateY(-2px); filter: brightness(1.15); }
.social-btn.facebook { background: #1877F2; }
.social-btn.twitter { background: #000; }
.social-btn.whatsapp { background: #25D366; }
.social-btn.linkedin { background: #0A66C2; }
.social-btn.email { background: #6366f1; }

.copy-row {
  display: flex;
  gap: 8px;
}

.copy-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: white;
  padding: 8px 12px;
  font-size: 13px;
  font-family: inherit;
  outline: none;
}

.embed-textarea {
  resize: none;
  font-family: monospace;
  font-size: 11px;
}

.copy-btn {
  background: #3b82f6;
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s;
}

.copy-btn:hover { background: #2563eb; }
.copy-btn.copied { background: #22c55e; }
</style>
